import axios from "axios";
import { jobRequestInquiriesUrl } from "../utils";

export const fetchJobRequestInquiries = (jobRequestId: string) => {
  return axios.get(jobRequestInquiriesUrl(jobRequestId));
};
